
import { OwnerModalComponent } from './owner-modal/owner-modal.component';

const PermissionModule =
  angular.module('topbroker.sharedPermission', [])
    .component('ownerModal', OwnerModalComponent)
    .name;

export default PermissionModule;
